// Nombre de usuario para mostrar: primera letra en mayúscula (david → David, trini → Trini).
// Los user_id se guardan en minúscula; en UI deben verse capitalizados.
export function capitalizeName(name) {
  const s = String(name || "").trim();
  if (!s) return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
}
